export const SET_ACCESS_PROCESS_LIST = 'SET_ACCESS_PROCESS_LIST';

// Action creators
export const setAccessProcessList = (value: any[]) => ({
  type: SET_ACCESS_PROCESS_LIST,
  payload: value,
});